<template>
  <div>
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <SelectInput v-model="activeTab" id="tabs" name="tabs" @input="onSelect">
        <option v-for="(tab, i) in tabs" :key="tab.href+'-'+i" :selected="tab.current" :value="tab.href">{{ tab.name }}</option>
      </SelectInput>

    </div>
    <div class="hidden sm:block">
      <nav class="isolate flex divide-x divide-gray-200" aria-label="Tabs">
        <inertia-link v-for="(tab, tabIdx) in tabs" :key="tab.name" :href="tab.href" :class="[tab.current ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700', tabIdx === 0 ? 'rounded-tl-lg' : '', tabIdx === tabs.length - 1 ? 'rounded-tr-lg' : '', 'group relative min-w-0 flex-1 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10']" :aria-current="tab.current ? 'page' : undefined">
          <span>{{ tab.name }}</span>
          <span aria-hidden="true" :class="[tab.current ? 'bg-indigo-500' : 'bg-transparent', 'absolute inset-x-0 bottom-0 h-0.5']" />
        </inertia-link>
      </nav>
    </div>
  </div>
</template>

<script>
import SelectInput from "../../../../Shared/SelectInput.vue";

export default {
  name: 'OrderTabs',
  components: {SelectInput},

  props: {
    active: {
      type: String,
      default: () => 'order'
    },
    orderId: Number,
  },

  data() {
    return {
      tabs: [
        { name: 'Order Details', href: route('customer.orders.show', this.orderId), current: this.active === 'order', key: 'order' },
        { name: 'Payment Information', href: route('customer.orders.payment-details', this.orderId), current: this.active === 'payment', key: 'payment' },
        { name: 'Fulfilment Details', href: route('customer.orders.fulfilment-details', this.orderId), current: this.active === 'delivery', key: 'delivery' },
        { name: 'Activities', href: route('customer.orders.activities', this.orderId), current: this.active === 'activity', key: 'activity' },
      ],
      activeTab: route(route().current(), this.orderId) || route('customer.orders.show', this.orderId),
    }
  },
  methods: {
    onSelect(tab) {
      console.log(route().current())
      this.$inertia.visit(tab)
    }
  }
}
</script>
